import autobind from 'core-decorators/lib/autobind';

import attachScript from 'widget/player-widget/utils/attach-script';
import { stringify } from 'widget/player-widget/utils/query-string';


const scriptApiUrl = 'https://player.vimeo.com/api/player.js';
const DEFAULT_VOLUME = 1;

let scriptPromise = null;


export default class VimeoExternal extends React.Component {

  static propTypes = {
    src: React.PropTypes.string.isRequired,
    onPlay: React.PropTypes.func,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
    simple: React.PropTypes.bool,
    mobileMode: React.PropTypes.bool,
    showControls: React.PropTypes.bool,
    paused: React.PropTypes.bool,
    loop: React.PropTypes.bool,
    muted: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.player = null;
    this.__volume = 0;

    // load once
    scriptPromise = scriptPromise || attachScript(scriptApiUrl);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src === this.props.src) {
      this.setSettings(nextProps, this.props);
    }
  }

  setSettings({ paused, loop, muted }, prevProps = {}) {
    if (!this.player) {
      return null;
    }

    if (prevProps.paused !== paused) {
      this.togglePaused(paused);
    }

    this.toggleLoop(loop);
    this.toggleMute(muted);
  }

  togglePaused(paused) {
    this.player
      .getPaused()
      .then(currentPaused => {
        if (paused && !currentPaused) {
          this.player.pause();
        }

        if (!paused && currentPaused) {
          this.player.play();
        }
      });
  }

  toggleLoop(loop) {
    if (loop) {
      this.player.setLoop(true);
    } else {
      this.player.setLoop(false);
    }
  }

  toggleMute(muted) {
    if (muted) {
      this.player.getVolume()
        .then(volume => {
          this.__volume = volume;
        });
      this.player.setVolume(0);
    } else {
      const volume = this.__volume === 0 ? DEFAULT_VOLUME : this.__volume;
      this.player.setVolume(volume);
      this.__volume = 0;
    }
  }

  buildUrl({ src, simple, mobileMode }) {
    const query = {};

    if (simple || mobileMode) {
      query.badge = '0';
      query.portrait = '0';
      query.title = '0';
    }

    return `${src}${stringify(query)}`;
  }

  @autobind
  setIFrame(node) {
    if (!node) {
      this.player = null;
      return;
    }

    this.iframe = node;

    scriptPromise
      .then(() => {
        // Vimeo Player ready
        this.player = new window.Vimeo.Player(node);
        this.setSettings(this.props);
      });
  }

  render() {
    const props = _.pick(this.props, 'className', 'width', 'height');

    return (
      <iframe {...props}
              src={this.buildUrl(this.props)}
              frameBorder="0"
              allowFullScreen
              ref={this.setIFrame} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/video/external/vimeo.js